import { Link } from "react-router-dom";
import { FaFileUpload, FaEdit, FaSave } from 'react-icons/fa';

export const tableConstants = (permissions, uploadHandler, uploadSingleFileHandler, selectedFiles) => {
  let count = 1;
  let formatedData = [
    {
      title: 'SNo',
      render: () => {
        return <span>{count++}</span>;
      },
    },
    {
      title: 'class',
      render: rowData => {
        return <span>{rowData.programs.name}</span>;
      },
    },
    {
      title: 'view',
      render: rowData => {
        return <span>
          {rowData.timetable_docs &&
            <Link to={rowData.timetable_docs} target={"_blank"}>View</Link>}
        </span>
      },
    },
    {
      title: 'Upload',
      render: (rowData) => {
        const isFileSelected = selectedFiles[rowData.programs.id];
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="file"
              name={`timetable_${rowData.programs.id}`}
              id={`timetable_${rowData.programs.id}`}
              style={{ display: 'none' }}
              onChange={(e) => uploadHandler(e, rowData.programs.id)}
            />
            <label
              htmlFor={`timetable_${rowData.programs.id}`}
              style={{
                cursor: 'pointer',
                background: 'var(--color-primary)',
                color: 'var(--color-text-on-dark)',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '13px',
              }}
            >
              <FaFileUpload /> Upload
            </label>
            {isFileSelected && (
              <span style={{ color: 'var(--color-success-text)', fontSize: '12px' }}>
                ✅ {isFileSelected.name}
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: 'Action',
      render: rowData => {
        return <span>
          {rowData.timetable_docs ? <FaEdit
            style={{ color: "var(--color-link)", fontSize: "20px", cursor: "pointer" }}
            onClick={(e) => uploadSingleFileHandler(e, rowData.programs.id)}
          /> : <FaSave
            style={{ color: "var(--color-success-text)", fontSize: "20px", cursor: "pointer" }}
            onClick={(e) => uploadSingleFileHandler(e, rowData.programs.id)}
          />}
        </span>;
      },
    },
  ];
  return formatedData;
};
